import { useMutation } from '@tanstack/react-query';
import {
  create, getAll, getOneById, update,
} from '../requests/paymentProof';

const KEY = 'paymentProof';

const useCreatePaymentProof = () => useMutation({
  mutationKey: [KEY, 'create'],
  mutationFn: (data) => create(data),
});

const useGetAll = () => useMutation({
  mutationKey: [KEY, 'getAll'],
  mutationFn: (data) => getAll(data),
});

const useGetPaymentProofById = () => useMutation({
  mutationKey: [KEY, 'getOneById'],
  mutationFn: ({ data, headers }) => getOneById(data, headers),
});

const useUpdatePaymentProof = () => useMutation({
  mutationKey: [KEY, 'update'],
  mutationFn: (data) => update(data),
});
const paymentProofMutations = {
  useCreatePaymentProof,
  useGetAll,
  useGetPaymentProofById,
  useUpdatePaymentProof,
};

export default paymentProofMutations;
